import { createSelector } from 'reselect';
import { getCurrentUserID, getUsers } from './getUsers';
import { type ReduxStateShared, type User } from '~shared/types';

// Staff and seeded test accounts use either domain since the Fuze Health rebrand.
const EMPLOYEE_EMAIL_DOMAINS = ['@alto.com', '@fuzehealth.com'];

export const getCurrentUser: (state: ReduxStateShared) => User | undefined = createSelector(
  getUsers,
  getCurrentUserID,
  (users: User[], userID: number | null | undefined): User | undefined => {
    return (users || []).find((u) => u.id === userID);
  },
);

export const getCurrentUserUuid: (state: ReduxStateShared) => string | undefined = createSelector(
  [getCurrentUser],
  (user: User | null | undefined) => user?.uuid,
);

export const getCurrentUserEmail: (state: ReduxStateShared) => string | null | undefined = createSelector(
  [getCurrentUser],
  (user: User | null | undefined) => user?.email,
);

export const getCurrentUserIsEmployee: (state: ReduxStateShared) => boolean = createSelector(
  [getCurrentUser],
  (user: User | null | undefined) => {
    const email = user?.email?.toLowerCase();
    return !!email && EMPLOYEE_EMAIL_DOMAINS.some((domain) => email.endsWith(domain));
  },
);

export const getCurrentUserFirstName: (state: ReduxStateShared) => string | null | undefined = createSelector(
  [getCurrentUser],
  (user: User | null | undefined) => user?.first_name,
);
